import React, { useState } from "react";
import { UploadButton } from "@presentation/components/helpers/UploadButton";
import { UploadLibraryDialog } from "./UploadLibraryDialog";
import { useUploadStore } from "@presentation/stores/UploadStore";

interface UploadLibraryButtonProperties {
  projectId: string;
  onUploadSuccess?: () => void;
}

export const UploadLibraryButton: React.FC<UploadLibraryButtonProperties> = ({ projectId, onUploadSuccess }) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const { activeUploads } = useUploadStore();
  const uploadingCount = Object.values(activeUploads).filter((u) => (u.status === "uploading" || u.status === "pending") && u.type === "library").length;

  return (
    <>
      <UploadButton projectId={projectId} onClick={() => setIsDialogVisible(true)} title="Upload Libraries" uploadingCount={uploadingCount} />

      {isDialogVisible && <UploadLibraryDialog key={projectId} projectId={projectId} onClose={() => setIsDialogVisible(false)} onUploadSuccess={onUploadSuccess} />}
    </>
  );
};
